// set 'title' property on <img> based on their alt property so that browsers show a popup on hover
$(function() {    
  // https://stackoverflow.com/a/29765040
  $('img').each(function () {
    $this = $(this);
    if (!$this.attr('title') && $this.attr('alt')) {
        $this.attr('title', $this.attr('alt'));
    }
  });
});  
